import { render, staticRenderFns } from "./AgreementPage.vue?vue&type=template&id=206e94a8&scoped=true&"
import script from "./AgreementPage.vue?vue&type=script&lang=js&"
export * from "./AgreementPage.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPage.vue?vue&type=style&index=0&id=206e94a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e94a8",
  null
  
)

export default component.exports